import Vue from 'vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleLeft,
  faAngleRight,
  faBoltLightning,
  faCalendar,
  faCalendarAlt,
  faCaretDown,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleDown,
  faEllipsisV,
  faEllipsisVertical,
  faFileExport,
  faFilter,
  faList,
  faMagnifyingGlass,
  faPlus,
  faPlusSquare,
  faQuestion,
  fas,
  faSquare,
  faTable,
  faThumbTack,
} from '@fortawesome/free-solid-svg-icons'

import {
  faCircle0,
  faClockTwelve,
  faFolderGear,
  faGripDotsVertical,
  faPlayPause,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faBookmark as faBookmarkRegular,
  faSquare as faSquareRegular,
  faSquareCheck as faSquareCheckRegular,
  faSquareMinus as faSquareMinusRegular,
  faSquarePlus as faSquarePlusRegular,
} from '@fortawesome/free-regular-svg-icons'

import {
  faUpRightFromSquare as faUpRightFromSquareRegular,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons'

import App from './App.vue'
import router from './router/index'

// Import FireAppCheck to ensure App Check initialization
// eslint-disable-next-line no-unused-vars
import { fireanalytics, FireAppCheck } from './store/firebase'
import store from './store/store'

import logger from './plugins/logger'
import vuetify from './plugins/vuetify'
import { clearAllListeners } from './services/listenerRegistry'

import { registerWorker } from './utils/service-worker'

import './plugins/idle'
import './plugins/longpress'
import './plugins/xlsx'
import './plugins/underscoreExtensions'

/** @section {h4} Environment Variables */

const { NODE_ENV, VUE_APP_GOOGLE_PROJECT, VUE_APP_VERSION } = process.env
const isProdDestination = VUE_APP_GOOGLE_PROJECT === 'iadops-prod'
const isProd = isProdDestination || NODE_ENV === 'production'

/** @section {h4} Initialize Plugins */

logger.sentry.install(Vue, router)
logger.handle.env('iAdOps', VUE_APP_VERSION, isProd)

// Initialize Firebase App Check (if available)
if (FireAppCheck) {
  logger.console.info('Firebase App Check initialized successfully')
} else {
  logger.console.warn('Firebase App Check initialization skipped - App Check not configured in Firebase Console. Auth will proceed without App Check tokens.')
}

Vue.config.devtools = !isProd
Vue.prototype.$analytics = fireanalytics

/** @section {h4} Import Styles */

library.add(
  fas,
  faAngleLeft,
  faAngleRight,
  faBoltLightning,
  faBookmarkRegular,
  faCalendar,
  faCalendarAlt,
  faCaretDown,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircle0,
  faCircleDown,
  faClockTwelve,
  faEllipsisV,
  faEllipsisVertical,
  faFileExport,
  faFilter,
  faFolderGear,
  faGripDotsVertical,
  faList,
  faMagnifyingGlass,
  faPlayPause,
  faPlus,
  faPlusSquare,
  faQuestion,
  faSquare,
  faSquareCheckRegular,
  faSquareMinusRegular,
  faSquarePlusRegular,
  faSquareRegular,
  faTable,
  faThumbTack,
  faUpRightFromSquareRegular,
  faXmark,
)

// eslint-disable-next-line vue/component-definition-name-casing
Vue.component('font-awesome-icon', FontAwesomeIcon)

/** @section {h4} Create Vue Instance */

const vue = new Vue({
  router,
  store,

  computed: {
    prompt() {
      return this.isAppIdle ? 'inactive' : 'active'
    },
  },
  created() {
    store.dispatch('auth/watch', router)

    store.dispatch('layout/watch', router)
  },
  onIdle() {
    logger.console.info('User is inactive.')
  },
  onActive() {
    logger.console.info('User is active.')
  },

  vuetify,

  render(h) {
    return h(App)
  },
}).$mount('#app')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', registerWorker)
}

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', (event) => {
    if (event && event.persisted) {
      return
    }

    fireanalytics.event('goal_progress', {
      category: 'Auth',
      description: 'Snapshot Listener Cleanup Decision',
      label: 'Pagehide Cleanup Source=pagehide_unload Enabled=true',
    })

    clearAllListeners()
  })
}

export default vue
